var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseSmall = function SvgCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7189 3.21969C12.0118 2.92677 12.4866 2.92677 12.7795 3.21969C13.0724 3.51261 13.0724 3.98752 12.7795 4.28044L9.06017 8.0004L12.7795 11.7204C13.0724 12.0133 13.0724 12.4882 12.7795 12.7811C12.4867 13.074 12.0118 13.074 11.719 12.7811L7.9996 9.06114L4.28022 12.7811C3.98735 13.074 3.51252 13.074 3.21965 12.7811C2.92678 12.4882 2.92678 12.0133 3.21965 11.7204L6.93902 8.0004L3.21968 4.28044C2.92681 3.98752 2.92681 3.51261 3.21968 3.21969C3.51255 2.92677 3.98738 2.92677 4.28025 3.21969L7.9996 6.93965L11.7189 3.21969Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })));
};
export default SvgCloseSmall;